import T from 'prop-types';
import React from 'react';
import TechnicalError from '../../segments/exit/pages/TechnicalError';

import './style.css';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      error: null,
    };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  // eslint-disable-next-line no-unused-vars
  componentDidCatch(error = {}, { componentStack }) {
    const { setError } = this.props;
    setError(error);
  }

  render() {
    const { children, showStackTrace = true, title } = this.props;
    const { error } = this.state;

    if (error) {
      return (
        <TechnicalError
          error={error}
          showStackTrace={showStackTrace}
          title={title}
        />
      );
    }

    return children;
  }
}

ErrorBoundary.propTypes = {
  title: T.string,
  children: T.node,
  showStackTrace: T.bool,
  setError: T.func,
};

export default ErrorBoundary;
